import { createSelector } from '@ngrx/store';
import { List, Record } from 'immutable';
import {
  PubnubMessageEvent,
  PubnubPresenceEvent,
  PubnubStatusEvent,
} from 'src/app/shared/pubnub/pubnub-types';
import { AppState } from 'src/store/appstate';

export class PubnubStoreState extends Record({
  presence: null as PubnubPresenceEvent | null,
  status: null as PubnubStatusEvent | null,
  message: null as PubnubMessageEvent | null,
  channels: List<string>(),
  subscribedChannels: List<string>(),
}) {
  public presence: PubnubPresenceEvent | null;
  public status: PubnubStatusEvent | null;
  public message: PubnubMessageEvent | null;
  public subscribedChannels: List<string>;
}

export const selectPubnub = (state: AppState) => state.pubnub;

export function selectSubscribedChannels() {
  return createSelector(selectPubnub, (pubnub) => pubnub.subscribedChannels);
}

export function selectPubnubStatus() {
  return createSelector(selectPubnub, (pubnub) => pubnub.status);
}

export function selectPubnubMessage() {
  return createSelector(selectPubnub, (pubnub) => pubnub.message);
}
export function selectPubnubPresence() {
  return createSelector(selectPubnub, (pubnub) => pubnub.presence);
}
